export interface CompressImageOptions {
  
  maxSide?: number;
  
  quality?: number;
  
  minBytes?: number;
}


const DEFAULT_MAX_SIDE = 2560;

const DEFAULT_QUALITY = 0.9;

const DEFAULT_MIN_BYTES = 48 * 1024;

function toBlob(canvas: HTMLCanvasElement, type: string, quality: number): Promise<Blob | null> {
  return new Promise((resolve) => canvas.toBlob(resolve, type, quality));
}

function renamed(name: string): string {
  const base = name.replace(/\.[^./\\]+$/, '') || 'image';
  return `${base}.webp`;
}


export async function compressImage(file: File, options: CompressImageOptions = {}): Promise<File> {
  const { maxSide = DEFAULT_MAX_SIDE, quality = DEFAULT_QUALITY, minBytes = DEFAULT_MIN_BYTES } = options;
  if (file.type === 'image/gif' || file.size < minBytes || typeof createImageBitmap !== 'function') return file;
  let bitmap: ImageBitmap;
  try {
    bitmap = await createImageBitmap(file);
  } catch {
    return file;
  }
  try {
    const scale = Math.min(1, maxSide / Math.max(bitmap.width, bitmap.height));
    const width = Math.max(1, Math.round(bitmap.width * scale));
    const height = Math.max(1, Math.round(bitmap.height * scale));
    const canvas = document.createElement('canvas');
    canvas.width = width;
    canvas.height = height;
    const context = canvas.getContext('2d');
    if (!context) return file;
    context.imageSmoothingQuality = 'high';
    context.drawImage(bitmap, 0, 0, width, height);
    const blob = await toBlob(canvas, 'image/webp', quality);
    if (!blob || blob.type !== 'image/webp' || (scale === 1 && blob.size >= file.size)) return file;
    return new File([blob], renamed(file.name), { type: 'image/webp', lastModified: file.lastModified });
  } finally {
    bitmap.close();
  }
}
